<template>
  <div>
    <div
      style="
        display: flex;
        justify-content: space-between;
        background-color: #f0f0f0;
        padding: 10px;
        border-radius: 5px;
      "
    >
      <h4 style="margin: 0">Paso 4: Información de pago</h4>
      <h4 style="margin: 0">
        <span class="badge bg-primary">&nbsp;</span>
        <span class="badge bg-primary">&nbsp;</span>
        <span class="badge bg-primary">&nbsp;</span>
        <span class="badge bg-primary">4</span>
        <span class="badge bg-primary">&nbsp;</span>
      </h4>
    </div>
    <hr />
    <div class="progress">
      <div
        class="progress-bar"
        role="progressbar"
        style="width: 80%"
        aria-valuenow="80"
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12 mt-4">
          <div class="card p-3">
            <p class="mb-0 fw-bold h4">Métodos de Pago</p>
          </div>
        </div>
        <div class="col-12">
          <div class="card p-3">
            <div class="accordion" id="accordionExample">
              <!-- Panel para Transferencia Bancaria -->
              <div class="card">
                <div
                  class="card-header"
                  id="headingOne"
                  style="
                    background: #f8f9fa;
                    border-bottom: 1px solid #e9ecef;
                    padding: 0;
                  "
                >
                  <button
                    class="btn w-100 text-start"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTransferencia"
                    aria-expanded="true"
                    aria-controls="collapseTransferencia"
                    style="color: #007bff; text-decoration: none"
                  >
                    Transferencia Bancaria
                  </button>
                </div>
                <div
                  id="collapseTransferencia"
                  class="collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-8">
                        <p class="h4 mb-0">Resumen</p>
                        <p class="mb-0">
                          <span class="fw-bold">Producto:</span>
                          <span class="c-green">: {{ nombreProducto }}</span>
                        </p>
                        <p class="mb-0">
                          <span class="fw-bold">Precio:</span>
                          <span class="c-green">:$452.90</span>
                        </p>
                      </div>
                      <div class="card-body">
                        <h5 class="card-title">
                          Instrucciones para Transferencia Bancaria
                        </h5>
                        <p class="card-text">
                          Por favor sigue las siguientes instrucciones para
                          completar tu pago mediante transferencia bancaria.
                        </p>

                        <ul>
                          <li>
                            <strong>Nombre del Banco:</strong> Banco de Ejemplo
                          </li>
                          <li>
                            <strong>Número de Cuenta:</strong> 123 456 789
                          </li>
                          <li>
                            <strong>IBAN:</strong> ES79 2100 0813 6101 2345 6789
                          </li>
                          <li><strong>SWIFT/BIC:</strong> CAIXESBBXXX</li>
                          <li>
                            <strong>Nombre del Beneficiario:</strong> Empresa
                            XYZ
                          </li>
                          <li>
                            <strong>Referencia:</strong> Pago por
                            [Servicio/Producto]
                          </li>
                          <li><strong>Monto a Pagar:</strong> $452.90</li>
                        </ul>

                        <p class="card-text">
                          Por favor asegúrate de incluir la referencia del pago
                          para asegurar una rápida asignación del mismo a tu
                          cuenta.
                        </p>

                        <div class="alert alert-info" role="alert">
                          <p>
                            La transferencia puede tardar entre 1-3 días
                            laborales en ser procesada. Una vez confirmado el
                            pago, se activarán los servicios correspondientes.
                          </p>
                        </div>

                        <p>
                          Si tienes preguntas o necesitas ayuda, por favor
                          contacta nuestro soporte al cliente:
                        </p>
                        <ul>
                          <li><strong>Email:</strong> soporte@ejemplo.com</li>
                          <li><strong>Teléfono:</strong> +1 234 567 8900</li>
                        </ul>
                      </div>
                    </div>
                    <div>
                      <h2 class="mb-3">
                        Cargar Comprobante de Transferencia Bancaria
                      </h2>
                      <p>
                        Por favor, carga una imagen del comprobante de tu
                        transferencia bancaria para verificar tu pago.
                      </p>
                      <form @submit.prevent="submitImage" class="mt-3">
                        <div class="input-group mb-3">
                          <input
                            type="file"
                            class="form-control"
                            @change="handleFileUpload"
                            accept="image/*"
                          />
                          <button class="btn btn-primary" type="submit">
                            Subir Comprobante
                          </button>
                        </div>
                      </form>
                      <div
                        v-if="uploadStatus"
                        class="alert"
                        :class="{
                          'alert-success': !uploadStatus.includes('Error'),
                          'alert-danger': uploadStatus.includes('Error'),
                        }"
                      >
                        <p>{{ uploadStatus }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Panel para Kushki -->
              <!--               <div class="card">
                <div class="card-header" id="headingTwo"
                  style="background: #f8f9fa; border-bottom: 1px solid #e9ecef; padding: 0;">
                  <button class="btn w-100 text-start" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseKushki" aria-expanded="false" aria-controls="collapseKushki"
                    style="color: #007bff; text-decoration: none;">
                    Kushki
                  </button>
                </div>
                <div id="collapseKushki" class="collapse" aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-8">
                        <p class="h4 mb-0">Resumen</p>
                        <p class="mb-0">
                          <span class="fw-bold">Producto:</span>
                          <span class="c-green">: {{ nombreProducto }}</span>
                        </p>
                        <p class="mb-0">
                          <span class="fw-bold">Precio:</span>
                          <span class="c-green">:$452.90</span>
                        </p>
                        <p class="mb-0">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Atque
                          nihil neque
                          quisquam aut
                          repellendus, dicta vero? Animi dicta cupiditate, facilis provident quibusdam ab
                          quis,
                          iste harum ipsum hic, nemo qui!</p>
                      </div>
                      <div>
                        <form id="payment-form" @submit.prevent="requestToken">
                          <input placeholder="Card Number" type="text" v-model="card.number">
                          <input placeholder="Full Name" type="text" v-model="card.name">
                          <input placeholder="MM" type="text" v-model="card.expiryMonth">
                          <input placeholder="YY" type="text" v-model="card.expiryYear">
                          <input placeholder="CVC" type="text" v-model="card.cvc">
                          <button type="submit">Pay $49.99</button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- Panel para PayPal -->
              <!--               <div class="card">
                <div class="card-header" id="headingThree"
                  style="background: #f8f9fa; border-bottom: 1px solid #e9ecef; padding: 0;">
                  <h2 class="mb-0">
                    <button class="btn w-100 text-start" type="button" data-bs-toggle="collapse"
                      data-bs-target="#collapsePayPal" aria-expanded="false" aria-controls="collapsePayPal"
                      style="color: #007bff; text-decoration: none;">
                      PayPal
                    </button>
                  </h2>
                </div>
                <div id="collapsePayPal" class="collapse" aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-8">
                        <p class="h4 mb-0">Resumen</p>
                        <p class="mb-0">
                          <span class="fw-bold">Producto:</span>
                          <span class="c-green">: {{ nombreProducto }}</span>
                        </p>
                        <p class="mb-0">
                          <span class="fw-bold">Precio:</span>
                          <span class="c-green">:$452.90</span>
                        </p>
                        <p class="mb-0">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Atque
                          nihil neque
                          quisquam aut
                          repellendus, dicta vero? Animi dicta cupiditate, facilis provident quibusdam ab
                          quis,
                          iste harum ipsum hic, nemo qui!</p>
                      </div>
                      <div>
                        <input v-model="paypal.total" placeholder="Total" />
                        <input v-model="paypal.currency" placeholder="Currency" />
                        <input v-model="paypal.method" placeholder="Method" />
                        <button @click="processPayment">Pagar con PayPal</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
 -->
              <!-- Panel para Tarjeta de Crédito -->
              <!--               <div class="card">
                <div class="card-header" id="headingFour"
                  style="background: #f8f9fa; border-bottom: 1px solid #e9ecef; padding: 0;">
                  <h2 class="mb-0">
                    <button class="btn w-100 text-start" type="button" data-bs-toggle="collapse"
                      data-bs-target="#collapseCreditCard" aria-expanded="false" aria-controls="collapseCreditCard"
                      style="color: #007bff; text-decoration: none;">
                      Tarjeta de Crédito
                    </button>
                  </h2>
                </div>
                <div id="collapseCreditCard" class="collapse" aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-lg-5 mb-lg-0 mb-3">
                        <p class="h4 mb-0">Resumen</p>
                        <p class="mb-0">
                          <span class="fw-bold">Producto:</span>
                          <span class="c-green">: {{ nombreProducto }}</span>
                        </p>
                        <p class="mb-0">
                          <span class="fw-bold">Precio:</span>
                          <span class="c-green">:$452.90</span>
                        </p>
                        <p class="mb-0">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Atque
                          nihil neque
                          quisquam aut
                          repellendus, dicta vero? Animi dicta cupiditate, facilis provident quibusdam ab
                          quis,
                          iste harum ipsum hic, nemo qui!</p>
                      </div>
                      <div class="col-lg-7">
                        <form action="" class="form">
                          <div class="row">
                            <div class="col-12">
                              <div class="form__div">
                                <input type="text" class="form-control" placeholder=" ">
                                <label for="" class="form__label">Número de Tarjeta</label>
                              </div>
                            </div>

                            <div class="col-6">
                              <div class="form__div">
                                <input type="text" class="form-control" placeholder=" ">
                                <label for="" class="form__label">MM/AA</label>
                              </div>
                            </div>

                            <div class="col-6">
                              <div class="form__div">
                                <input type="password" class="form-control" placeholder=" ">
                                <label for="" class="form__label">Código CVV</label>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form__div">
                                <input type="text" class="form-control" placeholder=" ">
                                <label for="" class="form__label">Nombre en la tarjeta</label>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="btn btn-primary w-100">Enviar</div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <!-- Panel para Deuna -->
              <div class="card">
                <div
                  class="card-header"
                  id="headingTwo"
                  style="
                    background: #f8f9fa;
                    border-bottom: 1px solid #e9ecef;
                    padding: 0;
                  "
                >
                  <button
                    class="btn w-100 text-start"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseDeuna"
                    aria-expanded="true"
                    aria-controls="collapseDeuna"
                    style="color: #007bff; text-decoration: none"
                  >
                    Pago con De una
                  </button>
                </div>
                <div
                  id="collapseDeuna"
                  class="collapse show"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="h4 mb-0">Resumen</p>
                        <p class="mb-0">
                          <span class="fw-bold">Producto:</span>
                          <span class="c-green">{{ nombreProducto }}</span>
                        </p>
                        <p class="mb-0">
                          <span class="fw-bold">Precio:</span>
                          <span class="c-green">${{ precioProducto }}</span>
                        </p>
                        <h5 class="card-title mt-4">
                          Instrucciones para el Pago con De una
                        </h5>
                        <p class="card-text">
                          Escanea el código QR con tu aplicación móvil para
                          completar tu pago de manera segura y rápida.
                        </p>
                        <p class="mt-3">
                          Una vez escaneado el código, sigue las instrucciones
                          en tu aplicación móvil para finalizar el pago.
                        </p>
                        <div class="alert alert-info" role="alert">
                          <p>
                            El procesamiento del pago es inmediato. Si tienes
                            alguna dificultad, por favor contacta nuestro
                            soporte al cliente.
                          </p>
                        </div>
                        <p>
                          Si tienes preguntas o necesitas ayuda, por favor
                          contacta nuestro soporte al cliente:
                        </p>
                        <ul>
                          <li><strong>Email:</strong> soporte@ejemplo.com</li>
                          <li><strong>Teléfono:</strong> +1 234 567 8900</li>
                        </ul>
                      </div>
                      <div
                        class="col-md-4 d-flex justify-content-center align-items-center"
                      >
                        <img
                          src="@/assets/images/deuna.png"
                          alt="Código QR para pago"
                          class="img-fluid"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="btn btn-primary payment" @click="registrar">
            Continuar
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import { Kushki } from "@kushki/js";

export default {
  name: "Home",
  components: {},
  data() {
    return {
      kushki: null,
      card: {
        number: "",
        name: "",
        expiryMonth: "",
        expiryYear: "",
        cvc: "",
      },
      paypal: {
        total: "",
        currency: "USD",
        method: "paypal",
        intent: "sale",
        description: "Descripción del pago",
      },
      nombreProducto: "",
      precioProducto: 0,
      email: "",
      imageFile: null,
      uploadStatus: "",
    };
  },
  mounted() {
    this.nombreProducto =
      "Medical Records - Plan " + window.sessionStorage.getItem("nombrePlan");
    this.kushki = new Kushki({
      merchantId: "public-merchant-id", // Replace with your public merchant id
      inTestEnvironment: true,
    });
  },
  methods: {
    handleFileUpload(event) {
      this.imageFile = event.target.files[0];
    },
    async submitImage() {
      if (!this.imageFile) {
        this.uploadStatus = "Por favor seleccione un archivo para cargar.";
        return;
      }
      const formData = new FormData();
      formData.append("image", this.imageFile);

      try {
        const response = await api.post("/pagoimgs/" +
            window.sessionStorage.getItem("idPago"),
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        this.uploadStatus = "Imagen cargada con éxito: " + response.data.path;
      } catch (error) {
        console.error("Error al subir la imagen: ", error);
        this.uploadStatus = "Error al cargar la imagen.";
      }
    },
    login() {
      this.$router.push("Login");
    },
    modal() {
      this.$router.push("App");
    },
    requestToken() {
      this.kushki.requestToken(
        {
          amount: "49.99",
          currency: "USD",
          card: {
            name: this.card.name,
            number: this.card.number,
            cvc: this.card.cvc,
            expiryMonth: this.card.expiryMonth,
            expiryYear: this.card.expiryYear,
          },
        },
        (response) => {
          if (!response.code) {
            console.log(response);
            // Send token to your backend
            this.sendTokenToBackend(response.token);
          } else {
            console.error(
              "Error:",
              response.error,
              "Code:",
              response.code,
              "Message:",
              response.message
            );
          }
        }
      );
    },
    sendTokenToBackend(token) {
      const apiUrl = "/payments/charge"; // URL del endpoint en tu backend
      api
        .post(apiUrl, {
          token: token,
        })
        .then((response) => {
          console.log("Respuesta del backend:", response.data);
          // Aquí puedes manejar la respuesta del servidor, por ejemplo, mostrar un mensaje de éxito o error
        })
        .catch((error) => {
          console.error("Error al enviar el token al backend:", error);
          // Manejar errores, por ejemplo, mostrar un mensaje al usuario
        });
    },
    processPayment() {
      api.post("/paypal/pay", this.paypal)
        .then((response) => {
          // La respuesta debe incluir la URL de redirección de PayPal
          window.location.href = response.data;
        })
        .catch((error) => {
          console.error("Error al procesar el pago:", error);
        });
    },
    registrar() {
      this.$router.push("Registro05Completo");
    },
  },
};
</script>
<style src="@/assets/css/registro04FP.css" scoped></style>
